import { OrderLineItem, ShipTo } from "../types/types";
import { OrderSummaryDto } from "@lib/ShiOneClient";
import { normalizeString } from "@features/orders-features/functions/helpers";
import getAddress from "@features/orders-features/functions/getAddress";

function isOrderLineItemView(value: unknown): value is OrderLineItem {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Partial<OrderLineItem>;
  return typeof candidate.group === "string";
}

export function isOrderLineItemViewArray(
  value: unknown,
): value is OrderLineItem[] {
  return Array.isArray(value) && value.every(isOrderLineItemView);
}

export function getShipTo(order: OrderSummaryDto): ShipTo {
  return {
    contact: normalizeString(order.deliveryContact),
    recipient:
      normalizeString(order.shipTo?.addressName) ??
      normalizeString(order.shipTo?.attention),
    address: getAddress(order.shipTo),
  };
}

export function getInvoiceStatus(order: OrderSummaryDto): string {
  return order?.status?.toLowerCase() === "invoiced"
    ? "Invoiced"
    : "Not Invoiced";
}

export function hasInvoice(order: OrderSummaryDto): boolean {
  return order?.status?.toLowerCase() === "invoiced";
}
